import React, { Component } from "react";
//import React, { Component, Suspense } from 'react';

import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import Right from '../right/Right';
import './ColoringPage.css';
import { fetchInitialData3 } from "../fetchData";
import CatMenuDesktop from './common/CatMenuDesktop';
import ColoringDesktopView from './common/ColoringDesktopView';
import ColoringMobileView from './common/ColoringMobileView';
// Lazy load the components
// const ColoringDesktopView = React.lazy(() => import('./common/ColoringDesktopView'));
// const ColoringMobileView = React.lazy(() => import('./common/ColoringMobileView'));
import NoResult from './common/NoResult';
import * as action from './Actions';
import Service from '../service/Service';
import Cookies from "js-cookie";
const service = new Service();
import withLocation from "../../withLocation";
import PageDataContext from '../context';
import { AdSlot, DFPSlotsProvider } from 'react-dfp'
// import { Bling as GPT } from "react-gpt";

const gptAry = {
    "msite": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Msite_Description_336x280",
        slot: [[310, 100], [320, 50], [300, 250]],
        id: "div-gpt-ad-1671527726123-0",
    }
    // "desktop": {
    //     path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_BelowCatMenu_160x600",
    //     slot: [[310, 100], [320, 50], [300, 250]],
    //     slot: [160,600],
    //     id: "div-gpt-ad-1693281425170-0",
    // }
}


class ColouringPageLanding extends Component {
    constructor(props, context) {
        super(props, context);
        let initialData = [];
        let serverSideData = {};
        let categoryList = [];
        let categoryListAlphabeticaly = [];
        let filterSubCategory = [];
        let filterMainCategory = [];
        var selectedDeskCat = "";
        var selectedCatAry = [];
        var landingCat = [];
        var seoData = [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
            // Legacy react-router v5 API; kept for backward compatibility, currently unused
            // by react-router-dom v6's <StaticRouter>.
            serverSideData = props.staticContext.initialData['initialData'];
        } else if (context && context.initialData && context.initialData['initialData']) {
            // SSR data path: populated via the context.js Provider in App.js from the
            // server's renderToString() call (see src/server/index.js).
            serverSideData = context.initialData['initialData'];
        }
        console.log("serverSideData --- ", serverSideData);
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1) {
                initialData = serverSideData['data1']['result'];
                seoData = serverSideData['data1']['seoData'];
                landingCat = { subcategory: serverSideData['data1']['result'] };
            }
            if (serverSideData['data2'] && serverSideData['data2']['msg'] == 1 && serverSideData['data2']['result'] && serverSideData['data2']['result'][0]) {
                categoryList = serverSideData['data2']['result'][0];
            }

            if (serverSideData['data3'] && serverSideData['data3']['msg'] == 1) {
                categoryListAlphabeticaly = serverSideData['data3']['result'];
            }
        }
        // if (categoryList.allCategories[0] && categoryList.allCategories[0].length > 0) {
        //selectedDeskCat = '';//categoryList.allCategories[0][0].categoryName;
        // selectedCatAry = initialData.filter(function (item) {
        // return item.categoryName == selectedDeskCat;
        // });
        // }
        console.log("landingCat", landingCat);

        let metaTitle = '', metaDescription = '', metaKeywords = '';
        if (seoData && seoData[0] && seoData[0].pageTitle) {
            metaTitle = seoData[0].pageTitle;
        }
        if (seoData && seoData[0] && seoData[0].metaDescription) {
            metaDescription = seoData[0].metaDescription;
        }
        if (seoData && seoData[0] && seoData[0].metaKeywords) {
            metaKeywords = seoData[0].metaKeywords;
        }
        this.state = {
            page: "ColouringPageLanding",
            metaTitle: metaTitle,
            metaDescription: [{ "name": "description", "content": metaDescription },
            { "name": "keywords", "content": metaKeywords }],
            initialData: initialData,
            categoryList: categoryList,
            showMsiteCat: false,
            selectedDeskCat: selectedDeskCat,
            categoryListAlphabeticaly: categoryListAlphabeticaly,
            filterSubCategory: filterSubCategory,
            filterMainCategory: filterMainCategory,
            filterCategoryId: '',
            filterSearchVal: '',
            mainCategoryCont: 1,
            selectedCatAry: selectedCatAry,
            alphabetArray : ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            landingCat: landingCat,
            seoData: seoData,
            isApp: false,
            isMobile: false,
            hasMounted: false

        };

        this.qnaPageNo = 1;
        this.maxScroll = 0;
        this.timeout = 0;
        // this.totalCount = 20;
        if (selectedCatAry) {
            if (selectedCatAry.length > 9) {
                this.totalCount = 20;
            } else {
                this.totalCount = selectedCatAry.length;
            }
        } else {
            this.totalCount = 0;
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "colouringpages/getlandingpagedata",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 10
            })
        };
        let obj2 = {
            url: global.api_url + "colouringpages/getallmaincategory",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 10
            })
        };

        let obj3 = {
            url: global.api_url + "colouringpages/getallmaincategorynsubcatcount",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 10
            })
        };


        return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));

        // return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth });
        this.setState({ windowInner: window.innerWidth });
        this.pageData = this.pageData.bind(this);
        Cookies.set("mainCategoryCont", 1);
        window.addEventListener("scroll", this.pageData, false);
        if (document.querySelector(".top-category-descp")) {
            if (document.querySelector(".top-category-descp").offsetHeight <= 40) {
                document.querySelector(".read-more-less").style.display = "none";
            } else {
                document.querySelector(".top-category-descp").style.height = "42px";
                document.querySelector(".top-category-descp").classList.add("line-clamp");
            }
        }
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
        const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile, hasMounted: true });

    window.addEventListener('resize', this.handleResize);


 
    }

    

    opendropdown() {
        this.setState({ showMsiteCat: !this.state.showMsiteCat });
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        window.removeEventListener('resize', this.handleResize);
    }


    

    pageData() {
        console.log("Colouring Landing PageNo  -- ", this.qnaPageNo);
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.catData(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    catData(pageno, size) {
        var catName = this.state.selectedDeskCat;
        // catName = catName.split("-").join(" ");
        let postData = {
            "pagesize": size,
            "pageno": pageno
        }



        var url = global.api_ci_url + "coloringpages/getsubcategorylist";
        service.postServiceCall(url, postData).then((json) => {
            // console.log("catData -- ", json);
            if (json.msg == "1") {
                if (this.state.initialData && this.state.initialData[0].subcategory && this.state.initialData[0].subcategory.length > 0 && json.result) {
                    if (json.result.length > 9) {
                        this.totalCount = this.totalCount + 10;
                    }
                    let tempInitialData = [];
                    tempInitialData[0] = {
                        categoryId: this.state.initialData[0].categoryId,
                        categoryName: this.state.initialData[0].categoryName,
                        categoryDes: this.state.initialData[0].categoryDes,
                        subcategory: this.state.initialData[0].subcategory.concat(json.result)
                    }
                    this.setState({ selectedCatAry: tempInitialData });
                    // console.log("selectedCatAry selectedCatAry1:::: ",tempInitialData);
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    handleResize = () => {
        const isMobile = window.innerWidth <= 768;
        this.setState({ isMobile });
      };
    


    render() {
        const { isMobile, hasMounted } = this.state;

        //if (!hasMounted) return null;
        return (
            <div>
            <main className="main-container colouring-page">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <CatMenuDesktop eleRef={this} mainCategoryCont={this.state.mainCategoryCont} />
                <div className="colouringpage-content left">
                    <div className="title">
                        {!this.state.isApp &&
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>Coloring Pages & Printables</span>
                        </div>
                        }
                        <h1 className="B24_00 left" id="skipToH1" role="heading" tabIndex="0">{
                            this.state.seoData && this.state.seoData[0] && this.state.seoData[0].h1Headding ? this.state.seoData[0].h1Headding : ''
                        }</h1>
                        <div className="right filter" onClick={() => action.openCatgFilter(this)} tabIndex={0} role="button" aria-label="Filter"  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault(); // stop page scroll on Space

      action.openCatgFilter(this);

      // move focus to close button inside popup
      setTimeout(() => {
        const popupFocus = document.querySelector(
          ".catgFilter-top .close-ic[tabindex]"
        );
        if (popupFocus) popupFocus.focus();
      }, 0);
    }
  }}>
                            <span data-icon-font="K" className="icon M16_42 Dev_Fltr_icn"></span>
                            <span className="M16_42 Dev_Fltr_btn">Filter</span>
                        </div>
                        <input type="hidden" id="pgNo" value="" />
                    </div>
                    <div className="sub-container left">
                        <div className="data-container left">
                            {this.state.initialData ?
                                <div>
                                    {/* <Suspense fallback={<div>Loading...</div>}> */}
                                    {this.state.isMobile && (this.state.windowInner < 767) ? (
                                    <ColoringMobileView eleRef={this} />
                                    ) : (
                                    <ColoringDesktopView eleRef={this} />
                                    )}
                                    {/* </Suspense> */}
                                    {/* <ColoringDesktopView eleRef={this} />
                                    <ColoringMobileView eleRef={this} /> */}
                                    {(this.state.windowInner < 767) ?
                                        this.state.seoData && this.state.seoData != "" && this.state.seoData[0].supportiveContent != "" &&
                                        <div>
                                            {!this.state.isApp ? <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                                <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                                                {/* <GPT
                                                    adUnitPath={gptAry['msite']['path']}
                                                    slotSize={gptAry['msite']['slot']}
                                                    renderWhenViewable={false}
                                                /> */}
                                                 <DFPSlotsProvider
                                                    dfpNetworkId={gptAry['msite']['id']}
                                                    adUnit={gptAry['msite']['path']}
                                                    slotSize={gptAry['msite']['slot']}
                                                    renderWhenViewable={false}
                                                ></DFPSlotsProvider>
                                            </div> : ''}
                                             
                                            <div className="category-info-block R14_61">
                                                <div className="R14_61">
                                                    {this.state.seoData && this.state.seoData[0] && this.state.seoData[0].supportiveContent}
                                                </div>                                                
                                            </div>
                                            {this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor &&
                                                <div className="category-info-block R14_61">
                                                    <div className="R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.seoData[0].bottomDescription != "." && this.state.seoData[0].bottomDescription.length > 1 &&
                                                <div className="category-info-block R14_61">
                                                    <div className="R14_61">
                                                        {this.state.seoData[0].bottomDescription}
                                                    </div>
                                                </div>
                                            }

                                            {/* <div>
                                                <div className="category-info-block R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}>
                                                </div>
                                            </div> */}
                                        </div>
                                        : <div className="category-info-block R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}></div>
                                    }

                                </div>
                                :
                                <NoResult />
                            }
                        </div>
                    </div>
                </div>
            </main >
            {/* <div className="lhs-desktop-ad" >
                <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                <GPT
                    adUnitPath={gptAry['desktop']['path']}
                    slotSize={gptAry['desktop']['slot']}
                    renderWhenViewable={false}
                />
            </div> */}
            </div>
        )
    }
}

ColouringPageLanding.contextType = PageDataContext;

export default withLocation(ColouringPageLanding);
